<template>
  <b-dropdown
    class="custom_select"
    animation=""
    @input="(value) => $emit('input', newValue)"
    @change="$emit('change', newValue)"
    @active-change="toggle"
    :multiple="multiple"
    v-model="newValue"
    aria-role="list"
  >
    <button class="button is-primary" type="button" slot="trigger">
      <span>{{ selectedVal }}</span>
      <div :class="isOpen ? 'is-open open_icon' : 'open_icon'"></div>
    </button>

    <b-dropdown-item @click="changeVal(newPlaceholder)" :value="0" aria-role="listitem">
      <span>{{ newPlaceholder }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      v-for="(item, i) in options"
      :key="i"
      :value="item[keys[0]]"
      aria-role="listitem"
      @click="changeVal(item[keys[1]])"
    >
      <span>{{ item[keys[1]] }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    placeholder: {
      default: () => 'Выберите',
      type: String
    },
    multiple: {
      default: () => false,
      type: Boolean
    },
    options: {
      default: () => [],
      type: Array
    },
    keys: {
      default: () => [],
      type: Array
    },
    value: {}
  },
  data() {
    return {
      newPlaceholder: this.placeholder,
      selectedVal: this.placeholder,
      newValue: this.value,
      isOpen: false
    }
  },
  methods: {
    changeVal(val) {
      this.selectedVal = val
    },
    toggle(isOpen) {
      this.isOpen = isOpen
    }
  },
  updated() {
    this.options.forEach((option) => {
      if (this.value === option[this.keys[0]]) {
        this.selectedVal = option[this.keys[1]]
      }
    })
  }
}
</script>
